<div class="notification">
  <div class="message">{{ data }}</div>
</div>
<span class="dismiss" (click)="snackBarRef.dismiss()"></span>

